import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface PopupWithFormProps {
	open: boolean;
	onClose: () => void;
	title?: string;
	children?: React.ReactNode;
	actions?: React.ReactNode;
}

const PopupWithForm: React.FC<
	PopupWithFormProps
> = ({
	open,
	onClose,
	title,
	children,
	actions,
}) => {
	const theme = useTheme();
	const isMobileScreen = useMediaQuery(
		theme.breakpoints.down('sm')
	);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth='sm'
			sx={{
				'& .MuiDialog-container': {
					alignItems: 'flex-start',
				},
				'& .MuiDialog-paper': {
					margin: isMobileScreen
						? '3%'
						: '16px',
					maxHeight:
						'calc(100% - 32px)',
					display: 'flex',
					flexDirection: 'column',
					overflow: 'hidden',
					width: isMobileScreen
						? '94%'
						: 'auto',
				},
			}}
		>
			<DialogTitle>
				{title}
				<IconButton
					edge='end'
					color='inherit'
					onClick={onClose}
					aria-label='close'
					sx={{
						position: 'absolute',
						right: 16,
						top: 2,
					}}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent
				sx={{
					overflowY: 'auto',
					flexGrow: 1,
				}}
			>
				{children}
			</DialogContent>
			{actions && (
				<DialogActions>
					{actions}
				</DialogActions>
			)}
		</Dialog>
	);
};

export default PopupWithForm;
